export function hour(date) {
  return new Date(date).getHours();
}
